import React from 'react';
import cn from 'classnames';
import Image from 'next/image';
import { IFeaturedImage } from '../models/featured-image';

export interface IProps {
	title: string;
	coverImage: IFeaturedImage;
	classNames?: string;
	overlay?: boolean;
	videoAspectMobile?: boolean;
}

export default function ThumbnailImage({ title, coverImage, classNames, overlay = true, videoAspectMobile }: IProps) {
	const className = cn(`relative w-full`, videoAspectMobile ? 'aspect-video' : 'h-[320px] lg:h-[640px]');

	return (
		<div className={`relative w-full ${className}`}>
			<Image fill alt={`Cover Image for ${title}`} src={coverImage?.node.sourceUrl} className={cn(classNames)} />
			{overlay && <div className="kkd-gradient-dark-overlay-tl"></div>}
		</div>
	);
}
